import messages from '../locales/de_DE.json';

const lang = {
    messages: {
        ...messages,
    },
    locale: 'de-DE',
};
export default lang;
